/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ssc_TaglineInputs */

const en_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot. Share. Connect.`)
};

const es_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispara. Comparte. Conecta.`)
};

const fr_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photographiez. Partagez. Connectez.`)
};

const de_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnehmen. Teilen. Verbinden.`)
};

const ja_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影。共有。繋がる。`)
};

const zh_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拍摄。分享。连接。`)
};

const ar_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صوّر. شارك. تواصل.`)
};

const id_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potret. Bagikan. Hubungkan.`)
};

const it_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatta. Condividi. Connetti.`)
};

const ru_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снимай. Делись. Соединяй.`)
};

const pt_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografe. Compartilhe. Conecte.`)
};

const ko_ssc_tagline = /** @type {(inputs: Ssc_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`촬영. 공유. 연결.`)
};

/**
* | output |
* | --- |
* | "Shoot. Share. Connect." |
*
* @param {Ssc_TaglineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ssc_tagline = /** @type {((inputs?: Ssc_TaglineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ssc_TaglineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ssc_tagline(inputs)
	if (locale === "es") return es_ssc_tagline(inputs)
	if (locale === "fr") return fr_ssc_tagline(inputs)
	if (locale === "de") return de_ssc_tagline(inputs)
	if (locale === "ja") return ja_ssc_tagline(inputs)
	if (locale === "zh") return zh_ssc_tagline(inputs)
	if (locale === "ar") return ar_ssc_tagline(inputs)
	if (locale === "id") return id_ssc_tagline(inputs)
	if (locale === "it") return it_ssc_tagline(inputs)
	if (locale === "ru") return ru_ssc_tagline(inputs)
	if (locale === "pt") return pt_ssc_tagline(inputs)
	return ko_ssc_tagline(inputs)
});